import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  ICategoriaEvento,
  SonidoEvento,
  ICliente,
  TipoCategoria,
  ICreateCategoriaEvento,
  IUpdateCategoriaEvento,
} from 'modelos/src';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { CategoriaEventosService } from '../../../../../auxiliares/servicios/http/categoria-eventos.service';
import { LoginService } from '../../../../login/login.service';

@Component({
  selector: 'app-crear-editar-categoria-evento',
  templateUrl: './crear-editar-categoria-evento.component.html',
  styleUrl: './crear-editar-categoria-evento.component.scss',
  standalone: false,
})
export class CrearEditarCategoriaEventoComponent implements OnInit {
  data = inject<ICategoriaEvento>(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<CrearEditarCategoriaEventoComponent>>(MatDialogRef);
  helper = inject(HelperService);
  private service = inject(CategoriaEventosService);

  public loading = false;
  public form?: FormGroup;
  public title?: string;

  public clientePropio?: ICliente = LoginService.getCliente();
  public sonidos: SonidoEvento[] = ['Silencio', 'Campana', 'Sirena'];
  public modulos: TipoCategoria[] = [];

  private createForm() {
    this.form = new FormGroup({
      nombre: new FormControl(this.data?.nombre, Validators.required),
      prioridad: new FormControl(this.data?.prioridad, Validators.required),
      color: new FormControl(this.data?.color, Validators.required),
      sonido: new FormControl(
        this.data?.sonido || 'Campana',
        Validators.required,
      ),
      modulo: new FormControl(this.data?.modulo, Validators.required),
      atender: new FormControl(
        this.data?.atender || false,
        Validators.required,
      ),
      noDerivar: new FormControl(
        this.data?.noDerivar || false,
        Validators.required,
      ),
      notificar: new FormControl(
        this.data?.notificar || false,
        Validators.required,
      ),
      global: new FormControl(this.data?.global || false, Validators.required),
      default: new FormControl(
        this.data?.default || false,
        Validators.required,
      ),
    });
    // if (this.data.default) {
    //   this.form.get('nombre').disable();
    // }
  }

  public async onSubmit() {
    this.loading = true;
    let res = null;
    try {
      const data = this.getData();
      if (this.data?._id) {
        // Update
        await this.service.update(this.data._id, data);
        this.helper.notifSuccess('Código de Evento actualizado');
      } else {
        // Create
        res = await this.service.create(data);
        this.helper.notifSuccess('Código de Evento creado');
      }
      this.dialogRef.close(res?._id);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public getData(): ICreateCategoriaEvento | IUpdateCategoriaEvento {
    const data: ICreateCategoriaEvento | IUpdateCategoriaEvento =
      this.form?.value;
    return data;
  }

  async ngOnInit() {
    this.title = this.data?._id
      ? `Editar ${this.data.nombre}`
      : 'Crear categoría de evento';
    // Filtrar los módulos habilitados según el helper
    const modulosHabilitados = this.helper.modulosHabilitados();
    const tiposModuloPermitidos: TipoCategoria[] = [];
    modulosHabilitados.forEach((modulo: any) => {
      switch (modulo.nombre) {
        case 'moduloActivos':
        case 'moduloVehiculos':
          if (!tiposModuloPermitidos.includes('Activo'))
            tiposModuloPermitidos.push('Activo');
          // Las dashcams se asignan a vehículos, activos y colectivos.
          if (!tiposModuloPermitidos.includes('Dashcam'))
            tiposModuloPermitidos.push('Dashcam');
          break;
        case 'moduloColectivos':
          if (!tiposModuloPermitidos.includes('Otro'))
            tiposModuloPermitidos.push('Otro');
          if (!tiposModuloPermitidos.includes('Dashcam'))
            tiposModuloPermitidos.push('Dashcam');
          break;
        case 'moduloAlarmasDomiciliarias':
          if (!tiposModuloPermitidos.includes('Alarma'))
            tiposModuloPermitidos.push('Alarma');
          break;
        case 'moduloLuminarias':
          if (!tiposModuloPermitidos.includes('Luminaria'))
            tiposModuloPermitidos.push('Luminaria');
          break;
        case 'moduloAdministracion':
          if (!tiposModuloPermitidos.includes('Sistema'))
            tiposModuloPermitidos.push('Sistema');
          break;
        default:
          if (!tiposModuloPermitidos.includes('Otro'))
            tiposModuloPermitidos.push('Otro');
          break;
      }
    });
    this.modulos =
      tiposModuloPermitidos.length > 0
        ? tiposModuloPermitidos
        : ['Activo', 'Vehiculo', 'Alarma', 'Luminaria', 'Otro', 'Sistema', 'Dashcam'];
    this.createForm();
  }
}
